import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

function Info() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            MANCHESTER PSYCH FEST 2026 – FAQ / INFO
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Where
          </Typography>
          <Typography className="text">
            Multi-venue festival at The Apollo, Manchester Academy, The Ritz,
            Projekts Skate Park, Gorilla, YES, Deaf Institute, Circle Square,
            Sandbar, Lass O’Gowrie, The Abbey & The Bread Shed.
          </Typography>
          <Typography className="text">
            Ticket gains access to all venues. ***
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            When
          </Typography>
          <Typography className="text">Saturday 5th Sep 2026.</Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Live music line-up
          </Typography>
          <Typography className="text">
            {"Click "} <Link to="/2026/line-up">here</Link>{" "}
            {" to visit line-up A-Z page."}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Stage times & Map
          </Typography>
          <Typography className="text">
            {"Click "}{" "}
            <Link target="_blank" to="https://woov.to/manchesterpsychfest26">
              here
            </Link>{" "}
            {" for Stage times & Map via our free app on WOOV."}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Film Screenings
          </Typography>
          <Typography className="text">
            {"Click "} <Link to="/2026/film">here</Link>{" "}
            {" to visit our Film screenings page."}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Heads Talking
          </Typography>
          <Typography className="text">
            {"Click "} <Link to="/2026/heads-talking">here</Link>{" "}
            {" to visit our Heads Talking page."}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Food stalls
          </Typography>
          <Typography className="text">
            Street food will be available across the festival catering for all
            dietary requirements.
          </Typography>
          <Typography className="text">
            {"Click "} <Link to="/2026/food">here</Link>{" "}
            {" to visit our Food info page."}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Accessibility
          </Typography>
          <Typography className="text">
            {"Click "} <Link to="/2026/accessibility">here</Link>{" "}
            {" for accessibility info."}
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Tickets
          </Typography>
          <Typography className="text">
            SOLD OUT - JOIN OUR MAILING LIST BELOW LIST FOR ANY UPDATES.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Wristband Collection x Festival Hub
          </Typography>
          <Typography className="text"></Typography>
          <Typography className="text">
            {"Click "} <Link to="/wristband-collection">here</Link>{" "}
            {
              " for full details of our festival hub including art, workshops, yoga, food, drink and more."
            }
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Ages
          </Typography>
          <Typography className="text">
            Ages 14+ (before 11pm) Academy, o2 Ritz , Projekts Skate Park,
            Gorilla, Deaf Institute, The Bread Shed.
          </Typography>
          <Typography className="text">
            18+ YES, all venues after 11pm.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Getting to the festival
          </Typography>
          <Typography className="text">
            The festival is spread across Manchester Academy, O2 Ritz , Projekts
            Skate Park, Gorilla, Deaf Institute, The Bread Shed, YES and Circle
            Square (wristband collection). Your wristband gains access to all
            stages.***
          </Typography>
          <Typography className="text">
            All venues are accessible by road.
          </Typography>
          <Typography className="text">
            Manchester Oxford Rd Station (0.1 miles)
          </Typography>
          <Typography className="text">
            Closest Tram stop: St Peters Square (0.4 miles)
          </Typography>
          <Typography className="text">
            Manchester Piccadilly Station (0.7 miles)
          </Typography>
          <Typography className="text">
            Manchester Shudehill Bus Station (0.9 miles)
          </Typography>
          <Typography className="text">
            Manchester Victoria Station (1.0 miles)
          </Typography>
          <Typography className="text">Manchester Airport (8 miles)</Typography>
          <Typography className="text">Liverpool Airport (33 miles)</Typography>
        </div>

        <div className="text-section">
          <Typography className="text">* Line-up subject to change</Typography>
          <Typography className="text">** plus booking fees</Typography>
          <Typography className="text">
            *** Venue capacities are based on first come first serve so please
            arrive early for specific acts.
          </Typography>
          <Typography className="text">
            {
              "**** Each venue have their own T&C's, please refer to their websites for detailed info."
            }
          </Typography>
          <Typography className="text">
            E.g. some do not permit back packs or cameras.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@manchesterpsychfest.com</Typography>
        </div>
      </div>
    </Container>
  );
}
export default Info;
